import axios from "axios";
import vue from "../main";
import Cookie from "js-cookie";
import { GetAuthToken } from "rj-server-auth-token";
import {
  handleAxiosAndRouterToken,
  PARTNERS_TOKEN,
  removeAllCookie,
  toLogin
} from "../utils/loginUtils";
import { handleComplianceResponse } from "../utils/compliance";

// 接口白名单
const whiteList = ["/partners-center-admin/userAuthority/token/generate"];
let Api = axios.create({
  baseURL: window._env_.BASE_API,
  withCredentials: true,
  headers: {
    sysId: "be7b21f00c034675a75a270257275f24"
  }
});
// http请求拦截
Api.interceptors.request.use(
  async config => {
    // 当前语言环境（zh/en），后端合规检测按此返回对应语言的提示文案
    config.headers["Accept-Language"] = Cookie.get("language") || "en";
    config.headers["web-sign-server-auth"] = GetAuthToken({
      sysId: "be7b21f00c034675a75a270257275f24",
      accessKeySecret: "9174A3DE0A8940E2B1741324FBA75339"
    });

    // 请求白名单
    if (!whiteList.includes(config.url)) {
      await handleAxiosAndRouterToken();
      // 这个地方的时候必有token
      config.headers["token"] = Cookie.get(PARTNERS_TOKEN);
    }
    if (config.method === "get") {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http响应拦截器
Api.interceptors.response.use(
  res => {
    switch (res.data.status) {
      case "200":
        handleComplianceResponse(res.data);
        break;
      case "10001":
        vue.$notify({
          message: vue.$createElement(
            "div",
            res.data.err
              .split(/\n/)
              .map(item => vue.$createElement("div", item))
          ),
          type: "error"
        });
        break;
      case "403":
        removeAllCookie();
        toLogin();
        break;
      case "88888":
        if (window._env_.ENV === "pro") {
          window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        } else {
          window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        }
        break;
      default:
        if (res.data.err) {
          vue.$notify({
            title: res.data.err,
            type: "error"
          });
        }
    }
    return res;
  },
  async error => {
    if (error && error.isComplianceBlock) {
      return Promise.reject(error);
    }
    if (error.response.status && error.response.status === 403) {
      removeAllCookie();
      toLogin();
    } else if (error.response) {
      vue.$notify.error(error.response.data.err);
    } else {
      vue.$notify.error("系统异常");
    }
  }
);
export default {
  axios: Api,
  FORM_HEADER: {
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  },
  /**
   * 登录
   * @param params {object} 格式：{username:xxx, password:xxx}
   */
  backdoor: params => Api.get(`backdoorLogin/checkLogin?userId=${params}`),
  partnerCreat: params => Api.post("partner/create", params),
  channelCreat: params => Api.post("partner/channelRequest", params),
  getAllCountries: params => Api.get("area/getAllCountries", params),
  getCityByPartentId: id => Api.get("area/getCityByPartentId?parentId=" + id),
  getvads: (name, country) =>
    Api.get("partner/getvads?companyName=" + name + "&countryCode=" + country),
  getVadAndSubs: (name, country) =>
    Api.get(
      "partner/vadAndSubs?companyName=" + name + "&countryCode=" + country
    ),
  flowtempl: (type, sponsorType) =>
    Api.get("flow/templ/type/" + type + "?sponsorType=" + sponsorType),
  contractFlowtempl: documentId => Api.get("flow/templ/partner/" + documentId),
  partnerlistself: params => Api.get("partner/list/self?query=" + params),
  partnerlisttodo: params => Api.get("partner/list/todo?query=" + params),
  getAllPartnerTypes: () => Api.get("partnerTypes/getAllPartnerTypes"),
  partnerbaseinfo: documentId => Api.get("partner/baseinfo/" + documentId),
  partnerCurrencyBaseInfo: documentId =>
    Api.get("currency/partner/baseinfo/" + documentId),
  partnerlinkmans: documentId => Api.get("partner/linkmans/" + documentId),
  partnerlogs: documentId => Api.get("partner/logs/" + documentId),
  flowcurrinfo: documentId =>
    Api.get("flow/templ/curr/info?documentId=" + documentId),
  partnerflow: documentId => Api.get("partner/flow?documentId=" + documentId), // 流程审批节点
  channelconfirm: params => Api.post("partner/channel/confirm", params), //渠道确认
  partneraudit: params => Api.post("partner/audit", params), //审批操作
  partnerupdate: params => Api.put("partner/update", params), //重新提交申请
  channelResubmit: params => Api.put("partner/channelResubmit", params), //渠道重新提交申请
  partnerbind: params => Api.post("/partner/bind?documentId=" + params), //渠道绑定
  getHeader: () => Api.get("common/html"), //获取静态头部顶部
  getmenu: () => Api.get("menu/getmenu"), //获取菜单
  getuserslist: params => Api.get("users/list", params), //查询用户方法
  getusersByParams: params => Api.get("users/getByParams", params), //根据输入内容查询用户(工号/姓名/邮箱)
  rejectsteps: params => Api.get("partner/reject/steps", params), //查询用户方法
  getSysFlowStepInfo: () => Api.get("sysFlowStepInfo/getSysFlowStepInfo"), //查询用户方法
  getAnnoucements: () => Api.get("content/getAnnoucements"), //获取公告
  curruser: () => Api.get("users/curr/user"), //当前登录人,
  getallcontents: params => Api.get("content/queryByParams", params), //根据条件查询内容
  getSelfContent: params => Api.get("content/getSelf", params), //根据条件查询自己可见的资讯
  getallcontenttypes: () => Api.get("contentType/getAll"), //查询所有已激活的内容类型
  getAttachmentByObjectId: params =>
    Api.get("attachment/getByObjectId", params), //根据object_id查询附件
  getFileByObjectIdAndType: params =>
    Api.get("attachment/getByObjectIdAndType", params), //根据object_id和object_type查询附件
  addSysMenu: params => Api.get("menu/addSysMenu", params), //新增菜单
  updateSysMenu: params => Api.get("menu/updateSysMenu", params), //编辑菜单
  deleteSysMenu: params => Api.get("menu/deleteSysMenu", params), //删除
  getMenuList: () => Api.get("menu/getMenuList"), //获取菜单管理列表
  getSelectedSysMenu: params => Api.get("menu/getSelectedSysMenu", params), //获取被选中的菜单信息
  getAddMenuCode: params => Api.get("menu/getAddMenuCode", params), //获取新增菜单code
  addInterface: params => Api.get("interface/addSysInterface", params), //新增接口
  updateInterface: params => Api.get("interface/updateSysInterface", params), //编辑接口
  deleteInterface: params => Api.get("interface/deleteSysInterface", params), //删除接口
  getInterfaceList: () => Api.get("interface/getInterfaceList"), //获取接口列表
  getSelectedInterface: params =>
    Api.get("interface/getSelectedSysInterface", params), //获取被选中的接口信息
  getAddInterfaceCode: params =>
    Api.get("interface/getAddInterfaceCode", params), //获取新增接口code
  getAreaList: params => Api.get("area/getAreaList", params), //获取区域列表信息
  addArea: params => Api.post("area/addArea", params), //新增区域信息
  getSelectedArea: params => Api.get("area/getSelectedArea", params), //获取被选中区域
  editArea: params => Api.put("area/editArea", params), //修改区域
  queryAreaUserList: () => Api.get("users/queryAreaUserList"), //获取区域经理列表
  getUserOfAreaList: params => Api.get("users/getUserOfAreaList", params), //获取该区域的区域经理列表
  getSaleOfArea: params => Api.get("users/saleOfArea?code=" + params), //获取该区域的所属销售
  getSaleOfViewArea: params => Api.get("users/saleOfViewArea?code=" + params), //获取该区域可查看权限的销售列表
  updateContent: params => Api.put("content/update", params), //修改内容信息
  updateContentStatus: params => Api.put("content/updateStatus", params), //修改内容信息
  addContent: params => Api.post("content/addContent", params), //新增内容信息
  getContentByPk: params => Api.get("content/queryByPk", params), //根据主键查询内容信息
  getTemplateList: () => Api.get("partner/templ/list"), // 获取签约模板列表
  addPartnerTempl: params => Api.post("partner/templ/create", params), // 新增签约模板
  updatePartnerTempl: params => Api.put("partner/templ/update", params), // 修改签约模板
  getRoleList: params => Api.get("role/list", params), //根据条件查询角色列表
  updateRole: params => Api.put("role/update", params), //修改角色信息
  getUsersInRole: params => Api.get("users/getUsersInRole", params), //查询属于该角色的用户列表
  getAllUsers: () => Api.get("users/getAllUsers"), //查询所有用户列表
  updateUsersOfRole: params => Api.put("userRole/updateUsersOfRole", params), //更新角色的用户列表
  getAllActiveMenu: () => Api.get("menu/getAllActiveMenu"), //查询所有启用的菜单
  getMenuByRole: params => Api.get("menu/getMenuByRole", params), //根据角色查询菜单列表
  updateMenuOfRole: params => Api.put("sysMenuRole/updateMenuOfRole", params), //修改角色菜单权限
  updateInterfaceOfRole: params =>
    Api.put("sysMenuRole/updateInterfaceOfRole", params), //修改角色接口权限
  getAllActiveInterface: () => Api.get("menu/getAllActiveInterface"), //查询所有启用的接口
  getInterfaceByRole: params => Api.get("menu/getInterfaceByRole", params), //根据角色编码查询接口权限列表
  getRoleByCode: params => Api.get("role/getRoleByCode", params), //根据角色编码查询角色
  //子账号二期
  bindForSubAccount: params => Api.post("account/bindForSubAccount", params), //主账号新增子账号
  getSelfAccount: params => Api.get("account/getSelfAccount", params), //查询自己子账号
  getAllSubAccount: () => Api.get("account/getAllSubAccount"), //查询所有子账号
  getAccountByMaster: params => Api.get("account/getAccountByMaster", params), //根据条件查询已绑定子账号
  bindToMaster: params => Api.post("account/bindToMaster", params), //子账号申请绑定主账号
  updateBindPartnerAccount: (documentId, targetUserId) =>
    Api.put(
      "account/bind/partner?documentId=" +
        documentId +
        "&targetUserId=" +
        targetUserId
    ), //改绑渠道主账号
  getUnHandleList: params => Api.get("account/getUnHandleList", params), //根据条件查询已绑定子账号
  passSubAccount: params => Api.post("account/passSubAccount", params), //主账号审批通过子账号绑定申请
  rejectSubAccount: params => Api.post("account/rejectSubAccount", params), //主账号审批通过子账号绑定申请
  unbindSubAccount: params => Api.put("account/unbind?subAccount=" + params), //主账号解除与子账号绑定
  editSubAccount: params => Api.put("account/editSubAccount", params), //更改子账号
  getCertificate: () => Api.get("certificate/list"), // 获取证书列表
  updateSubAccount: params => Api.put("account/updateSubAccount", params), //编辑子账号职位信息
  getAllWorkPost: () => Api.get("workPost/getAll"), //获取职位列表
  getUsersInfo: params => Api.get("users/getUsersInfo", params),
  getAllPartnerUsers: () => Api.get("users/getAllPartnerUsers"), //获取所有渠道用户
  getCompany: () => Api.get("partner/getCompany"), //获取主账号签约公司
  showRejectList: params =>
    Api.get("operationLog/getAccountRejectLogs", params), //查询子账号审批历史
  reBindToMaster: params => Api.put("account/reBindToMaster", params), //子账号重新申请绑定主账号
  getChannelByFk: documentId => Api.get("partner/getChannel/" + documentId), //根据签约查询渠道信息
  getMyRgid: () => Api.get("rgid/getMyRgid"), // 获取MyRgid
  bindRgid: params => Api.post("rgid/bindRgid", params), //绑定rgid
  getServicePolicy: top => Api.get("common/getServicePolicy?top=" + top), //获取海外官网Service Policy数据
  getAllRoles: () => Api.get("role/getAll"), //查询所有角色
  getUsersByFilter: params => Api.get("users/getList", params), //根据条件查询用户列表
  getUserRoles: params => Api.get("/userRole/getUserRoles?userId=" + params), //查询用户角色列表
  updateUserInfo: body => Api.put("/users/updateUser", body), //编辑用户
  getInfoCats: params => Api.get("/contentType/getByFilters", params), //根据条件查询信息类别列表
  addContentType: body => Api.post("/contentType/add", body), //创建信息类别
  updateContentType: body => Api.put("/contentType/update", body), //编辑信息类别
  deleteContentType: id => Api.delete("/contentType/delete/" + id), //删除信息类别
  getContentTypeCascaderData: params =>
    Api.get("/contentType/getCascaderData", params), //获取信息类别级联数据
  getAllContentTypes: () => Api.get("/contentType/getAll"), //获取所有信息类别
  getParentTypes: code => Api.get("/contentType/getAllParent/" + code), //获取所有信息父类别
  getContentPermissions: contentId =>
    Api.get("/channelNews/getByNews/" + contentId), //获取信息的签约类型权限列表
  updateNewsPageView: id => Api.put("/content/" + id + "/updatePageViews"), //更新信息访问量
  checkPermission: id => Api.get("/content/checkPermission?id=" + id), //验证是否有权限访问信息
  getSubTypes: parentCode =>
    Api.get("/contentType/" + parentCode + "/getSubTypes"), //查询信息三级类别
  getAttachmentOne: objectId =>
    Api.get("/attachment/getUeidtorAttachments?objectId=" + objectId), //根据id查询百度编辑器上传的附件列表
  getContentRootCats: () => Api.get("/contentType/getRootCats"), //查询信息1级类别
  getContentSecondCats: () => Api.get("/contentType/getSecondCats"), //查询信息2级类别
  doGetInterfaceData: body => Api.post("/interfaceData/doQuery", body), //查询接口数据
  getPartnerInfoByUser: () => Api.get("/partner/getPartnerInfoByUser"), //查询注册公司状态
  getLier2PartnerList: params => Api.get("partner/getZcPartnerList", params), //查询Vad下的注册签约列表
  getZcRzNumberByUser: params => Api.get("partner/getZcRzNumberByUser", params), //查询Vad下二级渠道注册数量
  doCertified: body => Api.post("/partner/certification", body), //发起认证注册签约渠道申请
  getTargetsByContract: documentId => Api.get("/target/partner/" + documentId), //获取VAD的销售任务
  addPartnerTarget: body => Api.post("/target/partner", body), //添加销售任务量
  updatePartnerTarget: body => Api.put("/target/partner", body), //编辑销售任务量
  getSalesValue: body => Api.post("/ecp/getVadsales", body), //从ecp获取销售额
  getSalesTarget: year => Api.get("/target/getSalesTarget?year=" + year), //获取年销售目标额
  getPartnerSales: partnerType =>
    Api.get("/target/getPartnerSales?partnerType=" + partnerType), //获取不同渠道任务量
  getAllContracts: companyName =>
    Api.get("/partner/all?companyName=" + companyName), //查询所有有限签约
  sendMailManually: params => Api.get("/mail/send", params), //手动发送邮件
  subAccountsZs: () => Api.get("/certificate/masterAccountCount"), //查询登录用户所有子账号的证书数量(根据RCPS/RCE分组)
  checkPartnerRole: () => Api.get("/users/checkUserRole"), //验证用户角色
  getRebateList: params => Api.get("/rebate/list/self", params), //根据登录用户查询返点列表
  getRebateDetail: params => Api.get("/rebate/detail/list", params), //根据登录用户查询返点列表
  getAvailable: params => Api.get("/rebate/available", params), //根据登录用户查询返点列表
  getRebateUsedList: params => Api.get("/rebate/list/used/self", params), //根据登录用户查询返点列表
  getAllBanners: () => Api.get("/content/getBanners"), //获取banners
  getRegionsByContent: contentId =>
    Api.get("/content/" + contentId + "/regions"), //获取信息授权区域列表
  getapreceivestate: () => Api.get("/partner/apReceiveState"), //查询当前登录用户的注册渠道和状态
  receiveApConfirm: body => Api.post("/partner/ap/receiveConfirm", body), //确认领取Ap
  getchannelaccount: companyName =>
    Api.get("/users/channelAccount?companyName=" + companyName), //根据渠道名称查询主账号
  getRebateMailContent: body => Api.post("/rebate/mail/content", body), //查询邮件内容
  sendRebateMail: body => Api.post("/rebate/mail/send", body), //发送返点邮件提醒
  activeOrDisableUser: body => Api.put("/users/activeOrDisable", body), //激活或禁用用户
  discardContract: params => Api.delete("/partner/discard?discardBody", params), //废弃签约信息
  getAllMasterAccount: keyword =>
    Api.get("/account/allMasterAccount?keyword=" + keyword), //获取主账号
  transferMasterAccount: body =>
    Api.post("/account/transferMasterAccount", body), //转移子账号
  getAllCurrency: () => Api.get("/currency/all"), //查询所有币种
  judgeHasRebatePerm: () => Api.get("/users/role/system"), //查询登录人是否有返利权限
  getAllRebateTypes: () => Api.get("/rebate/type/all"), //查询所有返利类型
  getPartnerRole: userId => Api.get(`users/role/partner?userId=` + userId),
  transferPartners: params => Api.get(`rebate/transferPartners`, params),
  transferRebate: body => Api.post(`rebate/transfer`, body),
  getToBeReceivePageList: params =>
    Api.get(`rebate/getToBeReceivePageList`, params),
  getTransferredPageList: params =>
    Api.get(`rebate/getTransferredPageList`, params),
  handleToBeReceived: body => Api.post(`rebate/handleToBeReceived`, body),
  discardRebateTransfer: body => Api.post(`rebate/discardTransfer`, body),
  addCreateTemplate: params => Api.post("partner/templ/createTemplate", params), // 新增签约模板
  getTemplate: () => Api.get("partner/templ/getTemplate"), // 获取签约模板列表
  getTemplateById: params =>
    Api.get("partner/templ/getTemplateById?id=" + params), //根据object_id查询附件
  updateTemplate: params => Api.put("partner/templ/updateTemplate", params), // 修改签约模板
  searchCustomer: params => Api.get(`customer/search`, params), // 搜索客户
  checkSimilarAccount: params =>
    Api.put("/customer/checkSimilarAccount", params), // 客户相似度校验
  postUpload: params => Api.post(`/common/ossUploadTemplate`, params), // 上传模版附件信息
  postOssUpload: params => Api.post(`/common/ossUpload`, params), // 上传附件信息
  // 用cookies获取token
  postGenerate: params =>
    Api.post(`/partners-center-admin/userAuthority/token/generate`, params),
  getFileBySingType: params => Api.post(`/common/getFileBySignType`, params),
  //大区经理审批  回显
  // getContentPermissions: (id) => Api.get("/partner/baseinfo/" + id),
  myPartnerExcel: params =>
    Api.get(`/partner/excel/self?query=${params}`, { responseType: "blob" }), //我的签约列表excel导出
  LierExport: params =>
    Api.get(`/partner/lier2/export?query=${params}`, { responseType: "blob" }), //二级渠道excel导出
  adminExcel: params =>
    Api.get(`partner/excel/admin?query=${params}`, { responseType: "blob" }), //管理员导出
  vadSaleExcel: params =>
    Api.get(`partner/excel/vadSale`, { responseType: "blob" }), //管理员导出
  getIpQuery: ip => Api.get(`/api/v1/ip/query?ip=${ip}`), //根据ip查询地址信息
};



// WEBPACK FOOTER //
// ./src/api/index.js